import ApolloLinkTimeout from 'apollo-link-timeout';
// https://wiki.indeed.com/display/PROF/Profile+GraphQL+Monitoring+and+Runbook
// Profile GraphQL query P95 SLO is 1200ms
// Profile GraphQL mutation P95 SLO is 450ms
// Timeout is set to 2450ms, 2250ms based on max(5 mutations, 1 query) + network latency 200 ms
const PROFILE_GRAPHQL_TIMEOUT_MS = 2450;
export const timeoutLink = new ApolloLinkTimeout(PROFILE_GRAPHQL_TIMEOUT_MS);
